import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { secondaryMarketProductCodeTypeChanged } from 'state/secondaryMarket/productSearch';
import type { EpicWithThunk } from 'state/state.common';

export function syncUserPreferenceProductCodeTypeEpic(): EpicWithThunk {
  return (actions$, _state$) => {
    return actions$.pipe(
      ofType('USER_PREFERENCES_SECONDARY_MARKET_PRODUCT_SEARCH_CODE_TYPE_CHANGED'),
      map(action => secondaryMarketProductCodeTypeChanged(action.codeType)),
    );
  };
}
